// extracted by mini-css-extract-plugin
export default {"StatusBar":"StatusBar_StatusBar__qwTYy","Logo":"StatusBar_Logo__vOOP6"};